import Vue from "vue";
import { SMApp, SMNotifications, SMUser } from "@/store";
import { RAuth } from "@/pages/Auth/RAuth";
import VueRouter from "vue-router";
import { isMaintenanceMode } from "@/utils/methods";
import { hasAuthToken } from "@/utils/authStorage";
import { isAuthRoutePath } from "@/utils/authRoutes";

const MAINTENANCE_MODE_ERROR_ROUTE = "Error503";

export const useRoutesChecker = (router: VueRouter) => {
  router.beforeEach((to, from, next) => {
    if (isMaintenanceMode()) {
      if (to.name === MAINTENANCE_MODE_ERROR_ROUTE) return next();

      return next({ name: MAINTENANCE_MODE_ERROR_ROUTE });
    }

    const toAuth = isAuthRoutePath(to.path);
    const fromAuth = isAuthRoutePath(from.path);

    if (toAuth && !fromAuth) {
      SMUser.unsetUser();
      SMNotifications.stopNotificationsRefresh();
      SMApp.resetAuthOnServer();
      Vue.auth.logout({ redirect: false });
    }

    if (!toAuth && !SMUser?.user && SMApp.authOnServer && !hasAuthToken()) {
      SMApp.resetAuthOnServer();

      return next(RAuth.path);
    }

    if (to.fullPath === "/" && to.fullPath !== from.path) return next(from.path);

    next();
  });
};
